"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableEncryptionType = exports.UnstructuredSubDataPointRecommendationStatus = exports.SubDataPointDataSubCategoryGuessStatus = exports.ConfidenceLabel = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.ConfidenceLabel = (0, type_utils_1.makeEnum)({
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
});
/** The approval status of the category guess for a subdatapoint */
exports.SubDataPointDataSubCategoryGuessStatus = (0, type_utils_1.makeEnum)({
    /** The guess has been approved as valid */
    Approved: 'APPROVED',
    /** The guess is pending review */
    Pending: 'PENDING',
    /** The guess has been marked as wrong */
    Rejected: 'REJECTED',
});
exports.UnstructuredSubDataPointRecommendationStatus = (0, type_utils_1.makeEnum)({
    /** The category was manually applied */
    ManuallyAdded: 'MANUALLY_ADDED',
    /** The recommendation has been corrected */
    Corrected: 'CORRECTED',
    /** The recommendation has been approved as valid */
    Validated: 'VALIDATED',
    /** The recommendation is has been made but not validated */
    Classified: 'CLASSIFIED',
    /** The recommendation has been marked as wrong */
    Rejected: 'REJECTED',
});
/**
 * Encryption types for database table
 */
exports.TableEncryptionType = (0, type_utils_1.makeEnum)({
    Unencrypted: 'UNENCRYPTED',
    EncryptedApplicationSide: 'ENCRYPTED_APPLICATION_SIDE',
    EncryptedByDataAtRest: 'ENCRYPTED_DATA_AT_REST',
});
//# sourceMappingURL=datapoint.js.map